<template>
 <div id="list">
  <dd-header></dd-header>
  <!-- 上部タブ -->
  <div class="container_main">
    <!-- 左部サイドバー -->
    <nav class="sidebar_left" v-if="isDispSideTab">
      <div class="side_menu">
        <section>
            <ul>
              <!-- <li>
                <a class="list_name" v-if="isUseSketchUpload" @click="showSketchList"
                  :class="{ 'active': isSketchList }">
                  <span>●</span>スケッチオーダー
                </a>
              </li> -->
              <li>
                <a v-if="userInfo.corpId == 170" class="list_name" @click="showSketchList"
                  :class="{ 'active': isSketchList }">
                  <span>●</span>スケッチオーダー管理
                </a>
              </li>
              <li>
                <a class="list_name" v-if="!isUsePropertyManagement" @click="showSalesList"
                  :class="{ 'active': isSalesList }">
                  <span>●</span>営業管理 → 受注処理
                </a>
              </li>
              <li>
                <a class="list_name" v-if="isUsePropertyManagement" @click="showPropertyList"
                  :class="{ 'active': isPropertyGroupPage }">
                  <span>●</span>物件管理 → 受注処理
                </a>
              </li>
              <li>
                <a class="list_name" @click="showConfirmedOrderList"
                  :class="{ 'active': isConfirmedOrderList }">
                  <span>●</span>受注管理 → 生産計画
                </a>
              </li>
              <li>
                <a class="list_name" @click="showOutputSheetList"
                  :class="{ 'active': isOutputSheetList }">
                  <span>●</span>生産指示 → 指示書出力
                </a>
              </li>
              <li>
                <a class="list_name" @click="showManufactureList"
                  :class="{ 'active': isManufactureList }">
                  <span>●</span>生産管理 → 完了処理
                </a>
              </li>
            </ul>
            <!-- <button @click="onClickSideTabToggle(false)">閉じる</button> -->
        </section>
      </div>
    </nav>
    <!-- <button v-if="!isDispSideTab" @click="onClickSideTabToggle(true)">→</button> -->
    <!--  メインコンテンツ  -->
    <main :style="{width: getMainWidth()}">
      <dd-sketch-plan-table
      ref="SketchOrderManagementTableRef"
      :isSketchList="isSketchList"
      :customNameList="customNameList"
      :dispForm="dispForm"
      @showDispModal="showDispModal"
      />
      <dd-sales-plan-table
      ref="SalesPlanTableRef"
      :isSalesList="isSalesList"
      :customNameList="customNameList"
      :dispForm="dispForm"
      @showDispModal="showDispModal"
      />
      <dd-confirmed-order-table
      ref="ConfirmedOrderTableRef"
      :isConfirmedOrderList="isConfirmedOrderList"
      :customNameList="customNameList"
      :dispForm="dispForm"
      @showDispModal="showDispModal"
      />
      <dd-output-sheet-table
      ref="OutputSheetTableRef"
      :isOutputSheetList="isOutputSheetList"
      :customNameList="customNameList"
      :dispForm="dispForm"
      @showDispModal="showDispModal"
      />
      <dd-manufacture-table
      ref="ManufactureTableRef"
      :isManufactureList="isManufactureList"
      :customNameList="customNameList"
      :dispForm="dispForm"
      @showDispModal="showDispModal"
      />
      <dd-property-table
      ref="PropertyTableRef"
      :isPropertyGroupPage="isPropertyGroupPage"
      :dispForm="propertyDispForm"
      @showPropertyDispModal="showPropertyDispModal"
      />
    </main>
    <!-- 表示項目切り替えモーダル -->
    <dd-plan-disp-modal ref="planDispRef"
      :isSketchList="isSketchList"
      :isSalesList="isSalesList"
      :isConfirmedOrderList="isConfirmedOrderList"
      :isOutputSheetList="isOutputSheetList"
      :isManufactureList="isManufactureList"
      :refDispForm="dispForm"
      :defaultDispForm="defaultDispForm"
      @onDisp="onDisp"
    />
    <!-- 表示項目切り替えモーダル(物件) -->
    <dd-property-disp-modal ref="propertyDispRef"
      :refDispForm="propertyDispForm"
      :defaultDispForm="defaultPropertyDispForm"
      @onDisp="onPropertyDisp"
    />
  </div>
  <dd-footer />
 </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import { API_URL, STORAGE_KEY } from '../constants/App'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import SketchOrderManagementTable from '../components/list/SketchOrderManagementTable'
import SalesPlanTable from '../components/list/SalesPlanTable'
import ConfirmedOrderTable from '../components/list/ConfirmedOrderTable'
import OutputSheetTable from '../components/list/OutputSheetTable'
import ManufactureTable from '../components/list/ManufactureTable'
import PropertyTable from '../components/list/PropertyTable'
import ListDispModal from '../components/list/modal/ListDispModal'
import PropertyDispModal from '../components/list/modal/PropertyDispModal'
export default {
  name: 'List',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-sketch-plan-table': SketchOrderManagementTable,
    'dd-sales-plan-table': SalesPlanTable,
    'dd-confirmed-order-table': ConfirmedOrderTable,
    'dd-output-sheet-table': OutputSheetTable,
    'dd-manufacture-table': ManufactureTable,
    'dd-property-table': PropertyTable,
    'dd-plan-disp-modal': ListDispModal,
    'dd-property-disp-modal': PropertyDispModal
  },
  data () {
    return {
      /** スケッチオーダーリスト表示フラグ */
      isSketchList: false,
      /** 営業管理リスト表示フラグ */
      isSalesList: false,
      /** 受注管理リスト表示フラグ */
      isConfirmedOrderList: false,
      /** 生産指示リスト表示フラグ */
      isOutputSheetList: false,
      /** 生産管理リスト表示フラグ */
      isManufactureList: false,
      /** 物件関連ページ表示フラグ */
      isPropertyGroupPage: false,
      /** 左サイドバー表示フラグ */
      isDispSideTab: true,
      /** 構成明細カスタム名一覧 */
      customNameList: [],
      dispForm: {},
      defaultDispForm: {
        sketchCheckList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        salesCheckList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41],
        orderCheckList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
        rotCheckList: [0, 1, 2, 3, 4, 5, 6],
        manufactureCheckList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41]
      },
      propertyDispForm: {},
      defaultPropertyDispForm: {
        propertyCheckList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        roomPlanCheckList: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
      },
      prevRoute: null,
      isReturn: false,
      dispList: {
        isSketchList: false,
        isSalesList: false,
        isConfirmedOrderList: false,
        isOutputSheetList: false,
        isManufactureList: false,
        isPropertyGroupPage: false
      }
    }
  },
  computed: {
    /** スケッチアップロードライセンスフラグ */
    isUseSketchUpload: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.sketchMenu
    },
    /** 物件管理ライセンスフラグ */
    isUsePropertyManagement: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.topPropertyMng
    },
    userInfo: function () {
      return App.getUserInfo()
    }
  },
  methods: {
    /** スケッチオーダーテーブル表示 */
    showSketchList: function () {
      this.clearFlag()
      this.isSketchList = true
      this.setListSelect()
      this.$refs.SketchOrderManagementTableRef.getSketchList(true)
    },
    /** 営業管理テーブル表示 */
    showSalesList: function () {
      this.clearFlag()
      this.isSalesList = true
      this.setListSelect()
      this.$refs.SalesPlanTableRef.getSalesList(true)
    },
    /** 受注管理テーブル表示 */
    showConfirmedOrderList: function () {
      this.clearFlag()
      this.isConfirmedOrderList = true
      this.setListSelect()
      this.$refs.ConfirmedOrderTableRef.getConfirmedOrderList(true)
    },
    /** 生産指示テーブル表示 */
    showOutputSheetList: function () {
      this.clearFlag()
      this.isOutputSheetList = true
      this.setListSelect()
      this.$refs.OutputSheetTableRef.getRotDataList(true)
    },
    /** 生産管理テーブル表示 */
    showManufactureList: function () {
      this.clearFlag()
      this.isManufactureList = true
      this.setListSelect()
      this.$refs.ManufactureTableRef.getManufactureList(true)
    },
    /** 物件管理テーブル表示 */
    showPropertyList: function () {
      this.clearFlag()
      this.isPropertyGroupPage = true
      this.setListSelect()
      this.$refs.PropertyTableRef.getPropertyList(true)
    },
    /** 表示項目切替モーダルを開く */
    showDispModal: function () {
      this.$refs.planDispRef.showModal()
    },
    /** 表示項目切替モーダル(物件)を開く */
    showPropertyDispModal: function (isDetailPage) {
      this.$refs.propertyDispRef.showModal(isDetailPage)
    },
    /** カスタム項目名を取得 */
    getCustomName: function () {
      axios.get(API_URL.ADMIN + '/get-bom-custom'
      ).then(response => {
        let data = response.data.data
        this.customNameList[0] = data.bomCustomName1 ? data.bomCustomName1 : 'カスタム１'
        this.customNameList[1] = data.bomCustomName2 ? data.bomCustomName2 : 'カスタム２'
        this.customNameList[2] = data.bomCustomName3 ? data.bomCustomName3 : 'カスタム３'
        this.customNameList[3] = data.bomCustomName4 ? data.bomCustomName4 : 'カスタム４'
        this.customNameList[4] = data.bomCustomName5 ? data.bomCustomName5 : 'カスタム５'
        this.customNameList[5] = data.bomCustomName6 ? data.bomCustomName6 : 'カスタム６'
        this.customNameList[6] = data.bomCustomName7 ? data.bomCustomName7 : 'カスタム７'
        this.customNameList[7] = data.bomCustomName8 ? data.bomCustomName8 : 'カスタム８'
        this.customNameList[8] = data.bomCustomName9 ? data.bomCustomName9 : 'カスタム９'
        this.customNameList[9] = data.bomCustomName10 ? data.bomCustomName10 : 'カスタム１０'
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 表示項目の更新 */
    onDisp: function (dispForm) {
      this.dispForm.sketchCheckList = Object.assign([], dispForm.sketchCheckList)
      this.dispForm.salesCheckList = Object.assign([], dispForm.salesCheckList)
      this.dispForm.orderCheckList = Object.assign([], dispForm.orderCheckList)
      this.dispForm.rotCheckList = Object.assign([], dispForm.rotCheckList)
      this.dispForm.manufactureCheckList = Object.assign([], dispForm.manufactureCheckList)
      App.setLocalStorage(STORAGE_KEY.PLAN_DISP, this.dispForm)
    },
    /** 表示項目の更新(物件) */
    onPropertyDisp: function (dispForm) {
      this.propertyDispForm.propertyCheckList = Object.assign([], dispForm.propertyCheckList)
      this.propertyDispForm.roomPlanCheckList = Object.assign([], dispForm.roomPlanCheckList)
      App.setLocalStorage(STORAGE_KEY.PROPERTY_DISP, this.propertyDispForm)
    },
    onClickSideTabToggle: function (dispState) {
      this.isDispSideTab = dispState
    },
    /** main要素の幅を取得 */
    getMainWidth: function () {
      if (this.isDispSideTab) {
        return 'calc(100% - 240px)'
      } else {
        return '100%'
      }
    },
    /** 表示制御フラグの初期化 */
    clearFlag: function () {
      this.isSketchList = false
      this.isSalesList = false
      this.isConfirmedOrderList = false
      this.isOutputSheetList = false
      this.isManufactureList = false
      this.isPropertyGroupPage = false
    },
    setListSelect: function () {
      App.setLocalStorage('PlanListSelect', {
        isSketchList: this.isSketchList,
        isSalesList: this.isSalesList,
        isConfirmedOrderList: this.isConfirmedOrderList,
        isOutputSheetList: this.isOutputSheetList,
        isManufactureList: this.isManufactureList,
        isPropertyGroupPage: this.isPropertyGroupPage
      })
    }
  },
  created: function () {
    this.getCustomName()
    // 表示項目の取得
    let dispForm = App.getLocalStorage(STORAGE_KEY.PLAN_DISP)
    let propertyDispForm = App.getLocalStorage(STORAGE_KEY.PROPERTY_DISP)
    if (Object.keys(dispForm).length > 0 && dispForm.salesCheckList) {
      this.dispForm = Object.assign({}, dispForm)
    } else {
      this.dispForm = Object.assign({}, this.defaultDispForm)
    }
    if (Object.keys(propertyDispForm).length > 0 && propertyDispForm.propertyCheckList) {
      this.propertyDispForm = Object.assign({}, propertyDispForm)
    } else {
      this.propertyDispForm = Object.assign({}, this.defaultPropertyDispForm)
    }
  },
  mounted: function () {
    /** ライセンスによる初期表示テーブルの切り替え */
    if (this.isUsePropertyManagement) {
      this.showPropertyList()
    // } else {
    //   if (!this.isReturn) {
    //     this.showSalesList()
    //   } else {
    //     if (this.isSketchList) this.showSketchList()
    //     if (this.isSalesList) this.showSalesList()
    //     if (this.isConfirmedOrderList) this.showConfirmedOrderList()
    //     if (this.isOutputSheetList) this.showOutputSheetList()
    //     if (this.isManufactureList) this.showManufactureList()
    //     if (this.isPropertyList) this.showPropertyList()
    //   }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
      // TODO 簡易化
      if (vm.prevRoute !== null) {
        if (vm.prevRoute.name === 'OrderDetail') {
          vm.isReturn = true
          vm.dispList = App.getLocalStorage('PlanListSelect')
          if (vm.dispList) {
            vm.dispList.isSketchList ? vm.isSketchList = true
              : vm.dispList.isSalesList ? vm.isSalesList = true
                : vm.dispList.isConfirmedOrderList ? vm.isConfirmedOrderList = true
                  : vm.dispList.isOutputSheetList ? vm.isOutputSheetList = true
                    : vm.dispList.isManufactureList ? vm.isManufactureList = true
                      : vm.dispList.isPropertyGroupPage ? vm.isPropertyList = true
                        : vm.isSalesList = true

            if (vm.isSketchList) vm.showSketchList()
            if (vm.isSalesList) vm.showSalesList()
            if (vm.isConfirmedOrderList) vm.showConfirmedOrderList()
            if (vm.isOutputSheetList) vm.showOutputSheetList()
            if (vm.isManufactureList) vm.showManufactureList()
            if (vm.isPropertyList) vm.showPropertyList()
          }
        } else {
          vm.showSalesList()
          if (vm.isUsePropertyManagement) {
            vm.showPropertyList()
          }
        }
      } else {
        vm.showSalesList()
        if (vm.isUsePropertyManagement) {
          vm.showPropertyList()
        }
      }
    })
  }
}
</script>
<style src="../css/list/list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/List.vue